const translation: Record<string, string> = {
  "site.name": "黑料吃瓜网",
  "site.tagline": "最新娱乐八卦热点聚合平台",
  "nav.home": "首页",
  "nav.about": "关于我们",
  "nav.category": "分类",
  "common.readMore": "阅读全文",
  "common.viewAll": "查看全部",
  "common.loading": "加载中...",
  "common.error": "出错了",
  "common.retry": "重试",
  "common.noData": "暂无内容",
  "home.title": "第一时间吃最劲爆的瓜",
  "home.subtitle": "汇聚娱乐圈最新黑料、明星八卦、热点事件与独家爆料",
  "home.cta": "立即吃瓜",
  "home.hotArticles": "热门八卦",
  "home.breakingNews": "重磅爆料",
  "home.categories": "分类吃瓜",
  "home.trending": "24小时热榜",
  "home.latest": "最新爆料",
  "category.allCategories": "全部分类",
  "category.noArticles": "暂无该分类文章",
  "article.related": "相关推荐",
  "article.tags": "标签",
  "article.author": "作者",
  "article.publishDate": "发布时间",
  "article.views": "阅读",
  "about.title": "关于黑料吃瓜网",
  "about.brand": "品牌介绍",
  "about.reputation": "平台口碑",
  "about.contact": "联系我们",
  "about.faq": "常见问题",
  "about.form.name": "您的称呼",
  "about.form.email": "电子邮箱",
  "about.form.message": "留言内容",
  "about.form.submit": "提交留言",
  "about.form.success": "留言已成功提交，感谢您的反馈！",
  "about.contact.email": "电子邮箱",
  "about.contact.hours": "客服时间",
  "footer.copyright": "版权所有",
  "footer.disclaimer": "本站内容仅供娱乐参考",
  "footer.privacy": "隐私政策",
  "footer.terms": "用户协议",
  "footer.disclaimer_link": "免责声明",
};

export default translation;